import { render, staticRenderFns } from "./NumberField2.vue?vue&type=template&id=277c99f7&scoped=true&"
import script from "./NumberField2.vue?vue&type=script&lang=js&"
export * from "./NumberField2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c99f7",
  null
  
)

export default component.exports